import React from "react";
import data from "../../../package.json";

export const Version = () => {
	// const { innerWidth, innerHeight } = window;
	console.log("V", data.version);
	return (
		<>
			<div className="fixed z-50 flex flex-col top-0 right-0 text-[8px] lg:text-[12px] text-white ">
				<span>v - {data.version}</span>
				{/* <span>
					w:{innerWidth} x h:{innerHeight}
				</span> */}
			</div>
		</>
	);
};
